/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormValidation from '../../atoms/formEnums/formValidation';
import Label from '../../atoms/label/label';
import Button, { ButtonType } from '../../atoms/button/button';
import { IconType } from '../../atoms/icon/icon';
import ColorPicker from '../../organisms/colorPickerModal/colorPickerModal';
import './formColorPicker.css';

const FormColorPicker = (props) => {
  const {
    validation, errorText, label, helpText, value, onChange, name, isGradient, disabled, alphaAllow
  } = props;
  const [colors, setColors] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [currentColorIndex, setCurrentColorIndex] = useState(0);
  useEffect(() => {
    if (isGradient) {
      const splitColors = value.split(",");
      setColors([
        splitColors[0] || "",
        splitColors[1] || ""
      ]);
    } else {
      setColors([value]);
    }
  }, [value, isGradient]);
  const onClickOpenModal = (colorIndex) => {
    setOpenModal(true);
    setCurrentColorIndex(colorIndex);
  };
  const onClickClear = () => {
    setColors([]);
    onChange({ target: { value: "" } });
  }
  const handleClose = (response) => {
    if (response !== undefined) {
      const newColors = [...colors];
      newColors[currentColorIndex] = response;

      setColors(newColors);
      const valueToSend = isGradient
        ? newColors.join(",")
        : newColors[0];

      onChange({ target: { value: valueToSend } });
    }

    setOpenModal(false);
  };
  const previewStyle = () => {
    if (!colors || !colors.length) return {};

    if (isGradient) {
      const c1 = colors[0];
      const c2 = colors[1];
      if (c1 && !c2) {
        return { background: c1 };
      }

      if (c1 && c2) {
        return {
          background: `linear-gradient(to right, ${c1}, ${c2})`
        };
      }
      return {};
    }
    return { background: colors[0] };
  };
  return (
    <div>
      <div className={`form-group row text-${validation}`}>
        {label && <Label helpText={helpText}>{label}</Label>}

        <div id={"colorPicker-" + name} className="col-sm-8" style={{ display: 'flex' }}>
          <div className="color_input">
            <input
              name={name}
              id={name}
              className="form-control"
              disabled
              type="text"
              value={isGradient ? colors.join(",") : colors[0] || ""}
            />
            <input
              name={name}
              id={name}
              className="form-control"
              disabled
              type="text"
              style={previewStyle()}
            />
          </div>
          <Button
            type={ButtonType.BUTTON}
            icon={IconType.COLOR}
            onClick={() => onClickOpenModal(0)}
            disabled={disabled || false}
          />
          {isGradient && (
            <Button
              type={ButtonType.BUTTON}
              icon={IconType.COLOR}
              onClick={() => onClickOpenModal(1)}
              disabled={disabled || false}
            />
          )}
          <Button
            id="palette-remove"
            type={ButtonType.BUTTON}
            icon={IconType.DELETE}
            onClick={() => onClickClear()}
            disabled={disabled || false}
          />

          { (validation === FormValidation.ERROR || validation === FormValidation.WARNING)
          && (
            <small className="form-text">{errorText}</small>
          )}
        </div>
      </div>
      {openModal && (
        <ColorPicker
          color={colors[currentColorIndex] || "#000000"}
          title={label}
          onClose={handleClose}
          alphaAllow={alphaAllow}
        />
      )}
    </div>
  );
};

FormColorPicker.propTypes = {
  validation: PropTypes.oneOf(Object.values(FormValidation)),
  errorText: PropTypes.string,
  label: PropTypes.string,
  helpText: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  isGradient: PropTypes.bool
};

FormColorPicker.defaultProps = {
  validation: FormValidation.PENDING,
  errorText: '',
  label: '',
  helpText: '',
  value: '',
  onChange: () => {},
  isGradient: false
};

export default FormColorPicker;